import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { CompaniesFactoringService } from '../../services/companies-factoring.service';
import { DashboardAddClient } from '../../interface/data.interface';
import { ConfigRutService } from 'src/app/services/config-rut.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';

@Component({
  selector: 'app-add-client-modal',
  templateUrl: './add-client-modal.component.html',
  styleUrls: ['./add-client-modal.component.scss'],
})
export class AddClientModalComponent implements OnInit {
  isMinuteCreate: boolean = false;
  rutForm: string;
  public validateRutSii: boolean = false;
  public clientRut: number = 0;
  public showRegister: number = 0;
  public userId: number;

  public form = new FormGroup({
    clientRut: new FormControl<string | ''>('', [Validators.required]),
    siiPass: new FormControl<string | ''>(''),
  });

  constructor(
    public dialogRef: MatDialogRef<AddClientModalComponent>,
    private configuracionRut: ConfigRutService,
    private service: CompaniesFactoringService,
    private router: Router,
    private auth: AuthService
  ) {}
  cerrarDialogo() {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.userId = parseInt(this.auth.getRutUser());
  }

  inputRut(event) {
    const { formattedRut, validation } = this.configuracionRut.changeRut(event);
    this.form.controls['clientRut'].setValue(formattedRut);
    if (!validation) {
      this.form.controls['clientRut'].setErrors({
        invalidRut: false,
      });
    }
    console.log(event);
    this.configuracionRut.transformStringRut(event.target.value);
    this.rutForm = formattedRut;
  }

  get fc() {
    return this.form.controls;
  }

  submit() {
    const requestBody: any = {
      companyRut: this.rutForm,
      siiPassword: this.form.value.siiPass,
      typeCompany: 'isClient',
      userId: this.userId,
    };
    let timerInterval: any;
    console.log(requestBody);
    this.clientRut = this.configuracionRut.transformStringRut(this.rutForm);
    console.log(this.clientRut);
    Swal.fire({
      title: 'Registrando Cliente',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        this.service.addNewCompanies(requestBody).subscribe({
          next: (e) => {
            if (requestBody.siiPassword) {
              timerInterval = setInterval(() => {
                this.validateSii(timerInterval);
              }, 15000);
              this.validateRutSii = true;
              this.dialogRef.close(this.isMinuteCreate);
            } else {
              console.log(e);
              if (e.validate == 2) {
                Swal.update({
                  title: e.message,
                  icon: 'warning',
                  didClose: () => {
                    this.dialogRef.close(this.isMinuteCreate);
                    Swal.hideLoading();
                  },
                });
                Swal.hideLoading();
              }
              if (e.validate == 1) {
                Swal.update({
                  title: 'Redirigiendo...',
                  icon: 'success',
                  showConfirmButton: false,
                });
                Swal.hideLoading();
                setTimeout(() => {
                  Swal.close(); // Cierra el modal de SweetAlert
                  this.dialogRef.close(this.isMinuteCreate); // Cierra el modal
                  this.router.navigateByUrl(
                    `/dashboards/files-clients?client=${this.clientRut}`
                  );
                }, 1500);
              }
              if (e.validate == 0) {
                Swal.fire({
                  title: e.message,
                  icon: 'success',
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.dialogRef.close(this.isMinuteCreate);
                    this.router.navigateByUrl(
                      `/dashboards/files-clients?client=${this.clientRut}`
                    );
                    this.validateRutSii = true;
                    this.isMinuteCreate = true;
                  }
                });
              }
            }
          },
          error: (error) => {
            if (error.status == 400) {
              console.log(error);
              Swal.fire({
                title: error.error,
                icon: 'info',
                showConfirmButton: true,
                confirmButtonText: `Ir a perfil`,
              }).then(() => {
                this.dialogRef.close(this.isMinuteCreate);
                this.router.navigateByUrl(
                  `/dashboards/files-clients?client=${this.clientRut}`
                );
              });
            } else {
              Swal.fire({
                title: error.error,
                icon: 'error',
                showConfirmButton: true,
                confirmButtonText: `Cerrar`,
              });
            }
          },
        });
      },
    });
  }

  validateSii(timerInterval: any) {
    let result;
    console.log(timerInterval);
    this.auth.validationStatus(this.clientRut).subscribe({
      next: (res) => {
        console.log(res);
        switch (res.content) {
          case 'Failed':
            console.log('failed');
            clearInterval(timerInterval);
            Swal.update({
              title: 'Cliente Registrado',
              icon: 'warning',
              text: 'Pero la clave tributaria es incorrecta',
              confirmButtonText: `Ir a perfil`,
              didClose: () => {
                this.validateRutSii = false;
                this.router.navigateByUrl(
                  `/dashboards/files-clients?client=${this.clientRut}`
                );
              },
            });
            Swal.hideLoading();

            break;
          case 'Succeed':
            clearInterval(timerInterval);
            Swal.update({
              icon: 'success',
              text: 'Clave tributaria correcta, Registro Realizado',
              confirmButtonText: `Ir a perfil`,
              didClose: () => {
                this.validateRutSii = false;
                this.router.navigateByUrl(
                  `/dashboards/files-clients?client=${this.clientRut}`
                );
              },
            });
            Swal.hideLoading();
            break;
          default:
            break;
        }
        res.content;
      },
    });
    return result;
  }
}
